import React, { useState, useContext } from "react"
import { useHistory } from "react-router-dom"

import LoadingContext from "../../../../contexts/loadingContext"
import RegistradorContext from "../../../../contexts/registradorContext"
import ServicosContext from "../../../../contexts/servicosContext"
import { useSnackbar } from "notistack"

import TelefoneMask from "../../../../masks/telefone"
import ReaisMask from "../../../../masks/reais"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"

import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles"
import AlertFixo from "@material-ui/lab/Alert"
import NativeSelect from "@material-ui/core/NativeSelect"
import SwapHorizIcon from "@material-ui/icons/SwapHoriz"
import InputAdornment from "@material-ui/core/InputAdornment"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import InputBase from "@material-ui/core/InputBase"
import FormLabel from "@material-ui/core/FormLabel"
import FormControl from "@material-ui/core/FormControl"
import Button from "@material-ui/core/Button"
import { Row, Col } from "react-bootstrap"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import MenuItem from "@material-ui/core/MenuItem"
import Slide from "@material-ui/core/Slide"
import InputLabel from "@material-ui/core/InputLabel"
import clsx from "clsx"
import IconButton from "@material-ui/core/IconButton"

import { EstabelecimentoAberto, RegistrarLogErro } from "../../../../services/clientefiel"

import { inserirPedidoMesa } from "../../../../services/integracao"

import { calcularValorTotal, carrinhoNovo } from "../../../../pages/RegistradorDePedidos/functions"

import { CadastrarPedido, AtualizarStatusPedido } from "../../../../services/cliente"
import { Avatar, Chip, Select, Tooltip } from "@material-ui/core"
import { Add, Payment, Remove } from "@material-ui/icons"

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const BootstrapInput = withStyles(theme => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        border: "1px solid #ced4da",
        fontSize: 16,
        padding: "18.5px 14px",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            borderRadius: 4,
            borderColor: "#80bdff",
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
    },
}))(InputBase)
const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        // zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
        // height: "100%",
        // minHeight: "-webkit-fill-available",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
    finalizaPedidoModal: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        "& > *, & > * > div, & > * > div > div": {
            display: "flex",
            flex: "1 0 25%",
            gap: "1rem",
            margin: 0,
        },
        "& > div": {
            display: "flex",
            gap: "1rem",
            flexWrap: "wrap",
        },
        "& #formaPagamento": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        "& #forma-pagamento-imagem": {
            display: "none",
        },
    },
    formaPagamentoImagem: {
        maxWidth: "2rem",
        marginRight: "0.25rem",
    },
    formaPagamentoItemLista: {
        display: "flex",
        justifyContent: "space-between",
        // width: '20rem'
    },
    ChipValorPromocional_positivo: {
        marginLeft: "0.75rem",
        backgroundColor: "#28a74596",
        display: "flex",
        justifyContent: "space-around",
        "& > div": {
            // Avatar
            [theme.breakpoints.down("sm")]: {
                display: "none",
            },
            backgroundColor: "#28a745",
            color: "#fff!important",
        },
    },
    ChipValorPromocional_negativo: {
        backgroundColor: "#dc354596",
        display: "flex",
        justifyContent: "space-around",
        "& > div": {
            // Avatar
            [theme.breakpoints.down("sm")]: {
                display: "none",
            },
            backgroundColor: "#dc3545",
            color: "#fff!important",
        },
    },
    ChipValorPromocional_icone: {
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
        // backgroundColor: isPositivo > 0 ? "#28a745" : "#dc3545",
        color: "#fff!important",
    },
}))

const ChipValorPromocional = ({ valor }) => {
    const classes = useStyles()

    const isPositivo = valor > 0

    if (!valor) return null

    return (
        <Chip
            className={
                isPositivo
                    ? classes.ChipValorPromocional_positivo
                    : classes.ChipValorPromocional_negativo
            }
            size="small"
            avatar={<Avatar className={classes.icone}>{isPositivo ? <Remove /> : <Add />}</Avatar>}
            label={
                <Typography component="span" variant="subtitle1" className={classes.porcentagem}>
                    {Math.abs(valor)}%
                </Typography>
            }
        />
    )
}

const SelecaoFormasDePagamento = ({ handleSelecaoFormaDePagamento, carrinho, formasPagamento }) => {
    const classes = useStyles()

    const disabled = !formasPagamento.length

    return (
        <Tooltip
            arrow
            title={
                disabled
                    ? "Formas de pagamento desativadas para pedidos de mesa, para ativar acesse a tela de configurações do sistema administrativo."
                    : ""
            }
        >
            <FormControl variant="outlined" disabled={disabled}>
                <InputLabel>Forma de Pagamento</InputLabel>
                <Select
                    id="formaPagamento"
                    label="Forma de Pagamento"
                    fullWidth
                    value={carrinho.formaPagamento.id ? carrinho.formaPagamento : null}
                    onChange={handleSelecaoFormaDePagamento}
                >
                    {formasPagamento.map(
                        forma =>
                            forma.ativo && (
                                <MenuItem
                                    key={forma.id}
                                    value={forma}
                                    className={classes.formaPagamentoItemLista}
                                >
                                    <div className={classes.formaPagamento_nome}>
                                        {forma.urlImagem ? (
                                            <img
                                                src={forma.urlImagem}
                                                alt={forma.descricao}
                                                className={classes.formaPagamentoImagem}
                                                id="forma-pagamento-imagem"
                                            />
                                        ) : (
                                            <Payment className={classes.formaPagamentoImagem} />
                                        )}
                                        {forma.descricao}
                                    </div>
                                    <ChipValorPromocional valor={forma?.desconto} />
                                </MenuItem>
                            )
                    )}
                </Select>
            </FormControl>
        </Tooltip>
    )
}

export default function Index() {
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const classes = useStyles()
    const theme = useTheme()
    const history = useHistory()

    const { setLoading, loading } = useContext(LoadingContext)

    const {
        setOpenFinalizacaoPedido,
        openFinalizacaoPedido,
        isPedidoMesa,
        numeroMesas,
        isRetiradaNoLocal,
        isDelivery,
        setCarrinho,
        cardapio,
        carrinho,
        setCardapio,
        valorDescontoManual,
        setValorDescontoManual,
        taxaServico,
        setTaxaServico,
        isFreteGratisMinimoEntrega,
        isFreteGratisDesconto,
        setOpenFormasDePagamento,
        descontoAtivoPagamento,
        setDescontoAtivoPagamento,
        ativarDesativarDescontoPagamento,
        ativarDesativarDesconto,
        ativoMinimoEntregaGratis,
        ativarMinimoEntregaGratis,
        descontoAtivo,
        setDescontoAtivo,
        setOpenCardapio,
        enderecoRetiradaNoLocal,
        fecharRegistradorModal,
    } = useContext(RegistradorContext)

    const { enqueueSnackbar } = useSnackbar()

    const { configuracoes } = useContext(ServicosContext)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const mesaURL = new URLSearchParams(window.location.search).get("mesa")
    const [mesa, setMesa] = useState(Number(mesaURL) ? mesaURL : null)

    const handleSelecaoFormaDePagamento = e => {
        const formaDePagamento = e.target.value

        const cart = Object.assign({}, carrinho)
        cart.formaPagamento = formaDePagamento

        setCarrinho(
            calcularValorTotal({
                carrinho: cart,
                cardapio,
                descontoAtivo,
                isDelivery,
                ativoMinimoEntregaGratis,
                valorDescontoManual,
                descontoAtivoPagamento,
                taxaServico,
            })
        )
    }

    function alterarDescontoManual(e) {
        console.log("alterarDescontoManual", e)
        try {
            setValorDescontoManual(e.floatValue)
            const cart = Object.assign({}, carrinho)
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual: e.floatValue,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "alterarDescontoManual", e)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function alterarTaxaServico(e) {
        console.log("alterarTaxaServico", e)
        try {
            const taxa = Number(e.target.value)
            if (isNaN(taxa)) {
                alertStart("Por favor, digite um número válido", "error")
                return
            }
            setTaxaServico(taxa)
            const cart = Object.assign({}, carrinho)
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                    taxaServico: taxa,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "alterarTaxaServico", e)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const adicionarPedidoAMesa = async pedido => {
        try {
            const response = await inserirPedidoMesa(autorizacao, pedido)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            let mesasAbertas
            if (!localStorage.getItem("mesasAbertas")) {
                mesasAbertas = new Array(50)
            } else {
                mesasAbertas = JSON.parse(localStorage.getItem("mesasAbertas"))
            }
            if (!mesasAbertas[pedido.mesa]) {
                mesasAbertas[pedido.mesa] = []
            }
            mesasAbertas[pedido.mesa].push(pedido)
            localStorage.setItem("mesasAbertas", JSON.stringify(mesasAbertas))
        } catch (error) {
            RegistrarLogErro(error, "inserirPedidoMesa", pedido)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function alterarTroco(e) {
        console.log("alterarTroco", e)
        try {
            const cart = Object.assign({}, carrinho)
            cart.troco = e.floatValue
            setCarrinho(cart)
        } catch (error) {
            RegistrarLogErro(error, "alterarTroco", e)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function alterarTaxaEntrega(e) {
        console.log("alterarTaxaEntrega", e)
        try {
            const cart = Object.assign({}, carrinho)
            cart.end.taxaEntrega = e.floatValue
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "alterarTaxaEntrega", e)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const enviarPedido = async () => {
        setLoading(true)
        // return true
        try {
            localStorage.setItem("taxaServico", carrinho.taxaServico)

            const cart = Object.assign({}, carrinho)
            cart.plataforma = `Central de Pedidos`
            cart.observacao = document.getElementById("observacaoPedido").value
            if (cart?.formaPagamento?.descricao != "DINHEIRO") {
                // cart.troco = document.getElementById('valorTroco').value
                // cart.troco = parseFloat(document.getElementById('valorTroco').value)
                cart.troco = null
            }

            cart.appNome = configuracoes.user?.parametros?.appNome
            cart.idCartelaCompleta = cardapio?.idCartelaCompleta
            cart.token = `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`

            //tentando corrigir erro de endereço ao enviar pedido
            if (isDelivery) {
                // const taxaAntiga = cart.end.taxaEntrega
                // cart.valorTotal -= taxaAntiga;
                // cart.end.taxaEntrega = parseFloat(document.getElementById('taxaEntrega').value)
                // cart.valorTotal += cart.end.taxaEntrega;

                if (configuracoes.user.parametros.tipoEntregaBairro == 1) {
                    cart.end.bairroEspecifico = 1
                } else {
                    cart.end.bairroEspecifico = 0
                }
            } else if (isRetiradaNoLocal || isPedidoMesa) {
                cart.end.taxaEntrega = 0.0
            }

            if (cart.valorTotal.toString() === "NaN") {
                setLoading(false)
                alertStart(
                    "O valor total está com algum erro. Verifique os dados digitados ou entre em contato com os desenvolvedores",
                    "error"
                )
                return false
            }

            if (isPedidoMesa) {
                if (!mesa) {
                    setLoading(false)
                    alertStart("Você precisa selecionar uma mesa.", "error")
                    return false
                } else {
                    cart.mesa = mesa
                }
            }

            const telefone = document.getElementById("telefonePedido")?.value?.replace(/\D/gim, "")

            cart.nomePedido = document.getElementById("nomePedido").value
            cart.telefoneCliente = telefone

            if (telefone && telefone.length > 0) {
                if (!(telefone.length === 11 || 10 === telefone.length)) {
                    alertStart("Digite o telefone do cliente", "error")
                    setLoading(false)
                    return false
                }
            }

            //DE ONDE FOI O PEDIDO

            if (isDelivery && (isFreteGratisMinimoEntrega || isFreteGratisDesconto)) {
                cart.valorEntrega = 0
                cart.taxaEntrega = 0
                cart.end.taxaEntrega = 0
            } else if (isDelivery) {
                cart.valorEntrega = cart.end.taxaEntrega
                cart.taxaEntrega = cart.end.taxaEntrega
            }

            if (isDelivery && document.getElementById("mudarParaRetiradaNoLocal").checked) {
                cart.tipoPedido = 1
                cart.valorEntrega = 0
                cart.taxaEntrega = 0
                cart.end = enderecoRetiradaNoLocal()
            }

            if (valorDescontoManual) {
                if (!cart.valorDesconto) {
                    cart.valorDesconto = 0.0
                }
                cart.valorDesconto += valorDescontoManual
            }
            //VERIFICA SE TA ABERTO A LOJA
            const retornoAberto = await EstabelecimentoAberto(
                cart.estabelecimento.id,
                aplicativoDados
            )
            if (retornoAberto.retornoErro) {
                //algum erro EstabelecimentoAberto
                alertStart(retornoAberto.mensagem, "error")
            } else {
                //tudo certoEstabelecimentoAberto

                delete cart.backUpValorDesconto

                cart.estabelecimento.online = retornoAberto.online

                if (retornoAberto.online == false) {
                    alertStart("Esse estabelecimento está fechado no momento", "warning")
                } else if (retornoAberto.online === true) {
                    const retornoPedido = await CadastrarPedido(cart, aplicativoDados)
                    if (retornoPedido.retornoErro) {
                        //algum erro CadastrarPedido
                        alertStart(retornoPedido.mensagem, "error")
                    } else {
                        //confirmar pedido
                        const data = {
                            id: retornoPedido.id,
                            token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
                            status: 0,
                        }
                        const retornoPedidoCorreto = await AtualizarStatusPedido(
                            data,
                            aplicativoDados
                        )
                        if (retornoPedidoCorreto.retornoErro) {
                            alertStart(retornoPedidoCorreto.mensagem, "error")
                        } else {
                            if (isPedidoMesa) await adicionarPedidoAMesa(retornoPedidoCorreto)

                            alertStart("Pedido Enviado!", "success")
                            setOpenCardapio(false)
                            setOpenFinalizacaoPedido(false)
                            setCarrinho(carrinhoNovo())
                            setCardapio({})
                        }
                    }
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "enviarPedido", carrinho)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
        setLoading(false)
    }

    return carrinho.itens.length && cardapio?.id ? (
        <Dialog
            open={openFinalizacaoPedido}
            TransitionComponent={Transition}
            keepMounted
            fullScreen={mobile}
            onClose={() => setOpenFinalizacaoPedido(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="responsive-dialog-informacoes-nome-pedido">
                <IconButton
                    className="setaVoltarModal"
                    onClick={() => {
                        setOpenFinalizacaoPedido(false)
                    }}
                >
                    <ArrowForwardIosIcon />
                </IconButton>
                {isDelivery
                    ? "PEDIDO PARA DELIVERY"
                    : isRetiradaNoLocal
                    ? "PEDIDO PARA RETIRADA"
                    : "PEDIDO PARA MESA"}
            </DialogTitle>
            <DialogContent>
                {isDelivery ? (
                    <Col xs={12} md={12} lg={12} id={"enderecoDeEntregaFinalizar"}>
                        <Typography>
                            <b>Entregar</b> na{" "}
                            {carrinho.end.logradouro + " - n°: " + carrinho.end.numero} - Bairro{" "}
                            {carrinho.end.bairro} - {carrinho.end.cidade + " - " + carrinho.end.uf}
                            <b> Complemento:</b> {carrinho.end.complemento} e <b>Referência: </b>
                            {carrinho.end.referencia}
                            <br />
                        </Typography>
                    </Col>
                ) : null}

                <div className={classes.finalizaPedidoModal}>
                    {cardapio.minimoEntregaGratis && cardapio.minimoEntregaGratis < 999 ? (
                        <Col xs={12} md={12} lg={12} style={{ margin: "1em 0" }}>
                            <AlertFixo
                                severity={ativoMinimoEntregaGratis ? "success" : "warning"}
                                style={{ width: "100%" }}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={ativarMinimoEntregaGratis}
                                    >
                                        {ativoMinimoEntregaGratis ? (
                                            <Button style={{ color: "#dc3545" }}>-</Button>
                                        ) : (
                                            <Button style={{ color: "#28a745" }}>+</Button>
                                        )}
                                    </IconButton>
                                }
                            >
                                Frete Grátis acima de{" "}
                                <b>
                                    {Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(cardapio.minimoEntregaGratis)}
                                </b>
                            </AlertFixo>
                        </Col>
                    ) : null}

                    {carrinho.valorDesconto || carrinho.backUpValorDesconto ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <AlertFixo
                                severity={descontoAtivo ? "success" : "warning"}
                                style={{ width: "100%" }}
                                action={
                                    <IconButton
                                        aria-label="close"
                                        color="inherit"
                                        size="small"
                                        onClick={ativarDesativarDesconto}
                                    >
                                        {descontoAtivo ? (
                                            <Button style={{ color: "#dc3545" }}>-</Button>
                                        ) : (
                                            <Button style={{ color: "#28a745" }}>+</Button>
                                        )}
                                    </IconButton>
                                }
                            >
                                {cardapio.cupomDesconto?.codigoCupom
                                    ? `Desconto (Cupom: ${cardapio.cupomDesconto?.codigoCupom})`
                                    : cardapio.informacao
                                    ? `Desconto (Info: ${cardapio.informacao}`
                                    : `Desconto`}
                            </AlertFixo>
                        </Col>
                    ) : null}

                    <div>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            defaultValue={carrinho?.cliente?.nome}
                            fullWidth
                            id="nomePedido"
                            label="Nome"
                            name="nomePedido"
                            type="text"
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            defaultValue={carrinho?.cliente?.telefone}
                            fullWidth
                            id="telefonePedido"
                            label="Telefone"
                            name="telefonePedido"
                            type="text"
                            InputProps={{
                                inputComponent: TelefoneMask,
                            }}
                        />
                    </div>

                    <div>
                        {isPedidoMesa ? (
                            <FormControl variant="outlined" fullWidth>
                                <InputLabel>Mesa</InputLabel>
                                <Select
                                    labelId="numeroDaMesaLabel"
                                    id="numeroDaMesa"
                                    value={mesa}
                                    label="Mesa"
                                    fullWidth
                                    variant="outlined"
                                >
                                    {numeroMesas.map(num => (
                                        <MenuItem
                                            key={num}
                                            value={num}
                                            onClick={() => setMesa(num)}
                                        >
                                            {"Mesa " + num}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        ) : null}

                        <SelecaoFormasDePagamento
                            handleSelecaoFormaDePagamento={handleSelecaoFormaDePagamento}
                            carrinho={carrinho}
                            formasPagamento={cardapio.formasPagamento}
                        />
                    </div>

                    <div>
                        {carrinho.descontoFormaPagamento ? (
                            <FormControl
                                className={clsx(classes.margin, classes.textField)}
                                fullWidth
                                variant="outlined"
                            >
                                {/* <InputLabel htmlFor="valorDesconto">{ (cardapio.cupomDesconto?.codigoCupom) ? `Desconto (Cupom: ${cardapio.cupomDesconto?.codigoCupom})` : ( (cardapio.informacao) ? `Desconto (Info: ${cardapio.informacao}` : `Desconto`)}</InputLabel> */}
                                <InputLabel htmlFor="valorDesconto">
                                    Desconto Forma de Pagamento
                                </InputLabel>
                                <OutlinedInput
                                    id="valorDescontoPagamento"
                                    // type={carrinho.valorDesconto ? 'text' : 'password'}
                                    type={"text"}
                                    value={Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(carrinho.descontoFormaPagamento)}
                                    disabled
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="valorDescontoPagamento"
                                                onClick={ativarDesativarDescontoPagamento}
                                                edge="end"
                                                style={{ width: "2rem", height: "2rem" }}
                                            >
                                                {descontoAtivoPagamento ? (
                                                    <span style={{ color: "#dc3545" }}>-</span>
                                                ) : (
                                                    <span style={{ color: "#28a745" }}>+</span>
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Desconto Forma de Pagamento"
                                />
                            </FormControl>
                        ) : null}

                        {carrinho.valorDesconto || carrinho.backUpValorDesconto ? (
                            <FormControl
                                className={clsx(classes.margin, classes.textField)}
                                fullWidth
                                variant="outlined"
                            >
                                <InputLabel htmlFor="valorDesconto">Desconto Automático</InputLabel>
                                <OutlinedInput
                                    id="valorDesconto"
                                    type={"text"}
                                    value={Intl.NumberFormat("pt-BR", {
                                        style: "currency",
                                        currency: "BRL",
                                    }).format(
                                        carrinho.valorDesconto
                                            ? carrinho.valorDesconto
                                            : carrinho.backUpValorDesconto
                                    )}
                                    disabled
                                    onChange={() => {}}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="valorDesconto"
                                                onClick={ativarDesativarDesconto}
                                                edge="end"
                                            >
                                                {descontoAtivo ? (
                                                    <Button style={{ color: "#dc3545" }}>-</Button>
                                                ) : (
                                                    <Button style={{ color: "#28a745" }}>+</Button>
                                                )}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Desconto Automático"
                                />
                            </FormControl>
                        ) : null}

                        {isDelivery ? (
                            isFreteGratisMinimoEntrega || isFreteGratisDesconto ? null : (
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    defaultValue={carrinho?.end?.taxaEntrega}
                                    fullWidth
                                    id="taxaEntrega"
                                    label="Taxa de Entrega"
                                    InputProps={{
                                        inputComponent: ReaisMask,
                                    }}
                                    onChange={alterarTaxaEntrega}
                                    name="taxaEntrega"
                                    type="text"
                                />
                            )
                        ) : null}

                        {carrinho?.formaPagamento?.descricao === "DINHEIRO" ? (
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                InputProps={{
                                    inputComponent: ReaisMask,
                                }}
                                onChange={alterarTroco}
                                defaultValue={"0"}
                                id="valorTroco"
                                label="Troco do Dinheiro"
                                name="valorTroco"
                            />
                        ) : null}
                        {descontoAtivo || descontoAtivoPagamento ? null : (
                            <TextField
                                variant="outlined"
                                margin="normal"
                                defaultValue={valorDescontoManual}
                                fullWidth
                                id="valorDescontoManual"
                                label="Desconto Manual"
                                InputProps={{
                                    inputComponent: ReaisMask,
                                }}
                                onChange={alterarDescontoManual}
                                name="valorDescontoManual"
                                type="text"
                            />
                        )}

                        {isPedidoMesa ? (
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                id="valorTaxaServico"
                                label="Taxa de Serviço"
                                value={taxaServico}
                                onChange={e => {
                                    e.persist()
                                    alterarTaxaServico(e)
                                }}
                                name="valorTaxaServico"
                                type="text"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                            />
                        ) : null}
                    </div>

                    <div>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            id="observacaoPedido"
                            label="Observação"
                            name="observacaoPedido"
                            type="text"
                        />
                    </div>
                    {isDelivery ? (
                        <Col
                            xs={12}
                            md={12}
                            lg={12}
                            style={{ marginTop: "1em", display: "flex", alignItems: "center" }}
                        >
                            <input
                                type="checkbox"
                                color="primary"
                                value={"mudarParaRetiradaNoLocal"}
                                name={"mudarParaRetiradaNoLocal"}
                                onClick={e => {
                                    console.log(e)
                                    if (e.target.checked) {
                                        document.getElementById(
                                            "enderecoDeEntregaCarrinho"
                                        ).style.display = "none"
                                    } else {
                                        document.getElementById(
                                            "enderecoDeEntregaCarrinho"
                                        ).style.display = ""
                                    }
                                }}
                                id={"mudarParaRetiradaNoLocal"}
                                style={{ width: "23px", height: "23px", cursor: "pointer" }}
                            />
                            <FormLabel
                                style={{ cursor: "pointer", margin: "0 0 0 1em" }}
                                htmlFor={"mudarParaRetiradaNoLocal"}
                                control={"mudarParaRetiradaNoLocal"}
                            >
                                {"Retirar No Local"}
                            </FormLabel>
                        </Col>
                    ) : null}
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        setOpenFinalizacaoPedido(false)
                    }}
                    style={{ color: "" }}
                >
                    Adicionar
                </Button>
                <Button
                    variant="contained"
                    disabled={loading}
                    color="primary"
                    onClick={enviarPedido}
                >
                    {`Confirmar ${Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }).format(carrinho.valorTotal)}`}
                </Button>
            </DialogActions>
        </Dialog>
    ) : (
        <React.Fragment></React.Fragment>
    )
}
